import { Container } from 'theme-ui';

export function FourZeroFourTemplate({ page, renderSections }) {
  return (
    <Container data-comp="FourZeroFourTemplate">{renderSections()}</Container>
  );
}
